import React from 'react';
import { Box } from '../Rebass';
import styled from '@emotion/styled';
import theme from '../../theme';

const Divider = styled(Box)(
  ({ color = 'baseGrayLight' }: { color: string }) => `
  height: 1px;
  width: 100%;
  border-bottom: 1px solid ${theme.colors[color]};
`,
);

export default Divider;
